import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { ComponentFunction } from "@glidejs/glide";
import Glide from "@glidejs/glide";
import { AxDropdown, IAxDropdownOptions, AxInput } from "@axess/limestone";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AxDatePicker, Cell, Mode } from "../../Components/AxDatepicker/AxDatepicker";

@ModuleName("RentalMain")
export class RentalMain implements AxInit {
    private Glides: Map<string, Glide.Static> = new Map<string, Glide.Static>();
    public _durationDropDown: AxDropdown = new AxDropdown();
    public _locationDropDown: AxDropdown = new AxDropdown();
    public _dateDropDown: AxDropdown = new AxDropdown();
    public _catDropDown: AxDropdown = new AxDropdown();
    private options: IRentalInitData;
    private filterUrl: string;

    public datePicker: AxDatePicker;

    constructor(private _requestHelper = new RequestHelper()) { }

    AxInit(init: IRentalInitData): void {

        const mobileInterface = new RentalMainMobilePortlet();
        mobileInterface.init(this, init);

        new AxInput('.ax-form-control').init();
        this.filterUrl = init.filterUrl;
        this.options = init;

        this.datePicker = new AxDatePicker();

        let endDate = init.endDate != null ? moment(init.endDate, "YYYY-MM-DD") : null;

        this.datePicker.Init({
            StartOfWeek: init.startOfWeek,
            Lang: init.lang,
            StartDate: moment(init.startDate, "YYYY-MM-DD"),
            DayRange: 0,
            Target: '#rental__startDate-picker',
            Mode: Mode.Inline,
            EndDate: endDate,
            monthsShown: 1
        });

        this.datePicker.ActivationSubject.subscribe(x => { this.setDate(x); });

        this._dateDropDown.init(`.rental_landing__date`,
            {
                searchBar: false,
                multiSelect: false
            });
        this._durationDropDown.init(`.rental_landing__duration`,
            {
                searchBar: true,
                multiSelect: false
            });
        this._locationDropDown.init(`.rental_landing__location`,
            {
                searchBar: true,
                multiSelect: false
            });
        this._catDropDown.init(`.rental_landing__cat`,
            {
                searchBar: true,
                multiSelect: false
            });

        $('.rental_landing-search').click(x => {
            this.search();
        });
        this.initGlider();
    }

    setDate(cell: Cell) {
        if (cell != null) {
            this._dateDropDown.setValue(cell.Date.format(this.options.datePattern));
            this._dateDropDown.close();
        }
    }

    search() {
        const arc = this._locationDropDown.getValue() as string;
        const duration = this._durationDropDown.getValue() as string;
        const cat = this._catDropDown.getValue() as string;
        const date: Cell = this.datePicker.ActivationSubject.getValue();

        let url = this.filterUrl;

        if (cat != null) {
            url += `/${cat}`;
        }

        if (duration != null) {
            url = this._requestHelper.insertParam(url, "dId", duration);
        }
        if (arc != null) {
            url = this._requestHelper.insertParam(url, "aId", arc);
        }
        if (date != null && date.Date != null) {
            url = this._requestHelper.insertParam(url, "date", date.Date.format('YYYY-MM-DD'));
        }

        window.location.href = url;
    }

    private initGlider() {
        $('.ax-products__groupList[data-display-mode="swiper"]').each((i, x) => {
            const glideID: string = $(x).attr('id');
            const rows: number = $(x).data('rows');
            const smallGap = $(x).hasClass('glid--sm');
            const glide = new Glide('#' + glideID, {
                type: 'slider',
                perView: rows,
                rewind: false,
                bound: true,
                animationDuration: 300,
                breakpoints: {
                    800: {
                        perView: 2
                    },
                    480: {
                        perView: 1
                    }
                },
                classes: {
                    activeSlide: 'glide__slide--active',
                    disabledArrow: 'glide__arrow--disabled'
                },
                gap: smallGap ? -18 : 0
            });

            this.Glides.set(glideID, glide);

            glide.on('run.before', e => {
                e.steps = e.direction === '>' ? -glide.settings.perView : glide.settings.perView
            })
            glide.mount({
                'DisableControls': this.updateGlideFunc
            });
        });
    }

    private updateGlideFunc: ComponentFunction = (glide: Glide.Static, Components: any, Events: any) => {

        const PREV_CONTROL_SELECTOR = "[data-glide-dir='<']";
        const NEXT_CONTROL_SELECTOR = "[data-glide-dir='>']";
        const component = {
            buildAfter() {
                this.prevBtn = Components.Html.root.querySelector(PREV_CONTROL_SELECTOR);
                this.nextBtn = Components.Html.root.querySelector(NEXT_CONTROL_SELECTOR);
            },
            handleDisable() {
                const perView = glide.settings.perView;
                const slidesCount = Components.Html.slides.length;

                this.prevBtn.disabled = (glide.index <= 0);
                this.nextBtn.disabled = (glide.index >= slidesCount - perView);
            },
            mount() {
            }
        };

        Events.on("build.after", function () {
            component.buildAfter();
            component.handleDisable();
        });
        Events.on("run.after", function () {
            component.handleDisable();
        });
        return component;
    }
}


class RentalMainMobilePortlet {
    private currentSelectionPosition: SearchStates = SearchStates.Location;
    private mainModule: RentalMain;

    private datePickerMobile: AxDatePicker;

    init(rentalMainModule: RentalMain, init: IRentalInitData) {
        this.mainModule = rentalMainModule;

        let endDate = init.endDate != null ? moment(init.endDate, "YYYY-MM-DD") : null;

        this.datePickerMobile = new AxDatePicker();
        this.datePickerMobile.Init({
            StartOfWeek: init.startOfWeek,
            Lang: init.lang,
            StartDate: moment(init.startDate, "YYYY-MM-DD"),
            DayRange: 0,
            Target: '#rental__Landing_search-date_picker',
            Mode: Mode.Endless,
            LegendTarget: '#rental__Landing_search-date__legend',
            EndDate: endDate,
            monthsShown: 1,
            scrollTargetQuerySelector: '.rental__Landing_search-date'
        });

        this.initEvents();
    }

    initEvents() {
        this.datePickerMobile.ActivationSubject.subscribe((x: Cell) => {
            if (x != null) {
                this.mainModule.datePicker.setDate(x.Date);
                this.currentSelectionPosition = SearchStates.Duration;
                this.toggleSelection();
            }
        });

        $('.rental__Landing_search-overlay .prod_selection__prod-close').click(x => {
            this.goBackOrClose();
        });

        $('.rental_landing__search-toggle-xs').on('click',
            () => {
                this.currentSelectionPosition = SearchStates.Location;
                this.resetSelections();
                this.toggleSelection();

                $('.rental__Landing_search-overlay').toggleClass('active');
            });

        $('#rental__Landing_search-ipt').on('keyup change', x => {
            const searchVal = $(x.delegateTarget).val() as string;

            if (this.isEmptyOrSpaces(searchVal)) {
                $('.rental__Landing_pLocationList .rental__Landing_pLocationEntry').addClass('ax-center-y').removeClass('d-none');
            }

            $('.rental__Landing_pLocationList .rental__Landing_pLocationEntry').each((i, e: HTMLElement) => {
                if (!e.innerText.includes(searchVal)) {
                    $(e).removeClass('ax-center-y').addClass('d-none');
                }
            });
        });

        $('.rental__Landing_search-skip').on('click',
            (e) => {
                if (this.currentSelectionPosition == SearchStates.Category) {
                    this.mainModule.search();
                }

                this.currentSelectionPosition++;
                this.toggleSelection();
            });

        $('.rental__Landing_pLocationEntry').on('click',
            (e) => {
                this.selectLocation(e);
            });

        $('.rental__Landing_pDurationEntry').on('click',
            (e) => {
                this.selectDuration(e);
            });

        $('.rental__Landing_pCategoryEntry').on('click',
            (e) => {
                this.selectCategory(e);
            });
    }

    goBackOrClose() {
        const originalPosition = this.currentSelectionPosition;
        this.currentSelectionPosition--;

        if (originalPosition !== SearchStates.Location) {
            switch (this.currentSelectionPosition) {
                case SearchStates.Duration:
                    this.mainModule._durationDropDown.resetSelection();
                    break;
                case SearchStates.Date:
                    this.mainModule.datePicker.resetDateSelection();
                    this.datePickerMobile.resetDateSelection();
                    this.mainModule._dateDropDown.resetSelection();
                    break;
                case SearchStates.Location:
                    this.mainModule._locationDropDown.resetSelection();
                    break;

            }
        } else {
            $('.rental__Landing_search-overlay').toggleClass('active');
            this.resetSelections();
        }
        this.toggleSelection();
    }

    resetSelections() {
        this.mainModule._durationDropDown.resetSelection();
        this.mainModule._catDropDown.resetSelection();
        this.mainModule._locationDropDown.resetSelection();
        this.mainModule._dateDropDown.resetSelection();
        this.datePickerMobile.resetDateSelection();
        this.mainModule.datePicker.resetDateSelection();
    }

    printSummary() {
        const currentLocationValue = this.mainModule._locationDropDown.getValue();
        const currentDateValue = this.mainModule._dateDropDown.getValue();
        const currentDurationValue = this.mainModule._durationDropDown.getValue();

        const wrapper = document.createElement('div');
        wrapper.classList.add('ax-pt-2', 'ax-my-1-n');

        if (currentLocationValue != null) {
            const innerWrapper = document.createElement('div');
            innerWrapper.classList.add('d-flex', 'ax-py-1');
            const locationElem = $(`.rental__Landing_pLocationEntry[data-value="${currentLocationValue}"]`).html();
            innerWrapper.innerHTML = locationElem;
            wrapper.appendChild(innerWrapper);
        }

        if (this.mainModule.datePicker.ActivationSubject.value != null) {
            const innerWrapper = document.createElement('div');
            innerWrapper.classList.add('d-flex', 'ax-py-1');

            const iconWrapper = document.createElement('div');
            const iconElem = document.createElement('i');
            iconElem.classList.add('las', 'la-calendar', 'ax-mr-2');
            iconWrapper.appendChild(iconElem);
            innerWrapper.appendChild(iconWrapper);

            const textWrapper = document.createElement('div');
            textWrapper.classList.add('text-h5');
            const currentCell: Cell = this.mainModule.datePicker.ActivationSubject.value;
            textWrapper.innerHTML = currentCell.Date.format('ll');
            innerWrapper.appendChild(textWrapper);
            wrapper.appendChild(innerWrapper);
        }


        if (currentDurationValue != null) {
            const innerWrapper = document.createElement('div');
            innerWrapper.classList.add('d-flex', 'ax-py-1');
            const locationElem = $(`.rental__Landing_pDurationEntry[data-value="${currentDurationValue}"]`).html();
            innerWrapper.innerHTML = locationElem;
            wrapper.appendChild(innerWrapper);
        }

        $('.rental__Landing_search-summary').html(wrapper);
    }

    selectDuration(e: JQuery.ClickEvent) {
        const value = $(e.delegateTarget).attr('data-value');
        this.mainModule._durationDropDown.setValue(value);
        this.currentSelectionPosition = SearchStates.Category;
        this.toggleSelection();
    }

    selectLocation(e: JQuery.ClickEvent) {
        const value = $(e.delegateTarget).attr('data-value');
        this.mainModule._locationDropDown.setValue(value);
        this.currentSelectionPosition = SearchStates.Date;
        this.toggleSelection();
    }

    selectCategory(e: JQuery.ClickEvent) {
        const value = $(e.delegateTarget).attr('data-value');
        this.mainModule._catDropDown.setValue(value);
        this.currentSelectionPosition = SearchStates.Send;
        this.mainModule.search();
    }

    toggleSelection() {
        if (this.currentSelectionPosition != SearchStates.Send) {
            this.printSummary();
        }
        $('.rental__Landing_search-location').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Location);
        $('.rental__Landing_search-date').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Date);
        $('.rental__Landing_search-duration').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Duration);
        $('.rental__Landing_search-category').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Category);

        $('.prod_selection__prod-close--cancel')
            .toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Location);
        $('.prod_selection__prod-close--back')
            .toggleClass('d-none', this.currentSelectionPosition === SearchStates.Location);
    }

    isEmptyOrSpaces(str) {
        return str === null || str.match(/^ *$/) !== null;
    }
}

enum SearchStates {
    Location = 1,
    Date = 2,
    Duration = 3,
    Category = 4,
    Send = 5
}

interface IRentalInitData {
    filterUrl: string;
    startOfWeek: number;
    startDate: string;
    endDate?: string;
    datePattern: string;
    lang: string;
}